function SidebarService($q) {
	'ngInject';

	const service = {
		setCurrentUserRoles: setCurrentUserRoles,
		getCurrentUserRoles: getCurrentUserRoles

	};

	const deferred = $q.defer();

	return service;

	function setCurrentUserRoles(currentUserRoles) {
		deferred.resolve(currentUserRoles);
	}

	function getCurrentUserRoles() {
		return deferred.promise;
	}
}

export default SidebarService;



/** WEBPACK FOOTER **
 ** ./client/components/sidebar/sidebar.service.js
 **/